import "./GameSwitcher.css";
import { useNavigate } from "react-router-dom";

export default function GameSwitcher({ currentGame, logoComponent }) {
    const navigate = useNavigate();

    const handleGameChange = (e) => {
        const selectedGame = e.target.value;
        if (selectedGame === 'world') {
            navigate('/');
        } else if (selectedGame === 'mk8dx') {
            navigate('/mk8dx');
        }
    };

    return (
        <div className="game-switcher">
            <label htmlFor="game-select" className="game-switcher-label">
                {logoComponent}
            </label>
            <select 
                id="game-select" 
                value={currentGame} 
                onChange={handleGameChange}
                className="game-select"
                aria-label="Select game mode"
            >
                <option value="world">MKWorld</option>
                <option value="mk8dx">MK8 Deluxe</option>
            </select>
        </div>
    );
}
